import React, { useState, useEffect, useRef, useMemo } from "react";
import { Box, BreadcrumbGroup, Button, Container, Grid, Alert, Input, Link, SpaceBetween, Spinner, StatusIndicator } from "@amzn/awsui-components-react";
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { AgGridReact } from 'ag-grid-react';
import { listFirstPassHistory } from "src/Ateam-BI/Templates/Utils/AppActivityUtilsAppsyncPlus";
import { convertToLocalTime } from "src/Ateam-BI/CorpReporting/Utility";
import FirstPassResultComponent from "./FirstPassResultComponent";
import { useSelector } from "react-redux";
import FirstPassAccessDeniedComponent from "./FirstPassAccessDeniedComponent";
import aiInsights from '../../../images/aiInsights.svg'
import { downloadFirstPassResults } from "../pdfUtils";

const FirstPassHistoryComponent = (props) => {
  const gridRef = useRef();
  const [entityList, setEntityList] = useState([]);
  const [quickFilterText, setQuickFilterText] = useState(null)
  const [viewResultsRequestDetails, setViewResultsRequestDetails] = useState(null)
  const [isLoading, setIsLoading] = useState(null);
  const [downloadRichLoader, setDownloadRichLoader] = useState({});
  const isPortalAdmin = useSelector((globalState)=>globalState.auth.isPortalAdmin)
  const isSupportAdmin = useSelector((globalState)=>globalState.auth.isSupportAdmin)
  const isFirstPassProFullUser = useSelector((globalState)=>globalState.auth.isFirstPassProFullUser)

  const defaultColDef = {
    // set filtering on for all columns
    filter: true,
    filterParams: {
      buttons: ['reset'],
      debounceMs: 200
    }
  };
  const columnDefs = useMemo(() => [
    { field: 'entity_code', headerName: 'Company Code', width: '160px', sortable: true, resizable: true },
    { field: 'entity_name', headerName: 'Entity Name', width: '250px', sortable: true, resizable: true },
    { field: 'current_year', headerName: 'Current Year', width: '150px', sortable: true, resizable: true },
    { field: 'previous_year', headerName: 'Prior Year', width: '150px', sortable: true, resizable: true },
    { field: 'invoke_method', headerName: 'Type Of Run', width: '150px', sortable: true, resizable: true },
    { field: 'execution_status', headerName: 'Status', width: '150px', sortable: true, resizable: true },
    {
      field: 'results',
      headerName: 'Results',
      width: '200px',
      sortable: true,
      resizable: true,
      cellRenderer: (params) => {
        const isLoadingRichPdf = downloadRichLoader?.[params?.data?.request_id];

        return (
          <SpaceBetween direction="horizontal" size="s">
            <Button onClick={() => fetchDetails(params?.data)}>View</Button>
            <Button
              iconName="download"
              variant="icon"
              onClick={() => downloadResults(params?.data)}
              disabled={isLoadingRichPdf}
            />
            {/* <Button
              onClick={() => downloadResultsPlain(params?.data)}
              variant="inline-link"
              disabled={isLoading}
            >
              {isLoading ? 'Downloading...' : <SpaceBetween direction="horizontal" size="xxs">Plain pdf <Icon name="download" /></SpaceBetween>}
            </Button> */}
          </SpaceBetween>
        );
      }
    },
    { field: 'created_at', headerName: 'Execution Date', width: '250px', sortable: true, resizable: true, cellRenderer: (params) => {return params.value || ''}, valueGetter: (params) => { return params?.data?.created_at ? convertToLocalTime(params.data.created_at, true) : ''} },
    { field: 'request_id', headerName: 'ID', width: '150px', resizable: true, sortable: true },
  ], [downloadRichLoader]);

  useEffect(() => {
    loadView()
  }, []);

  const loadView = () => {
    fetchAllHistory();
  }

  const downloadResults = async (data) => {
    await downloadFirstPassResults(
      data,
      () => setDownloadRichLoader(prev => ({ ...prev, [data.request_id]: true })),
      () => setDownloadRichLoader(prev => ({ ...prev, [data.request_id]: false })),
      'rich'
    );
  }

  const fetchDetails = async (data) => {
    setViewResultsRequestDetails(data)
  }

  const fetchAllHistory = (nextToken = null, accumulatedItems = []) => {
    setIsLoading(true);

    listFirstPassHistory(
      10000,
      nextToken,
      function onSuccess(response) {
        const items = response?.data?.listFirstPassHistory?.items || [];
        const newAccumulatedItems = [...accumulatedItems, ...items];
        const newNextToken = response?.data?.listFirstPassHistory?.nextToken;

        // If there's a nextToken, fetch more
        if (newNextToken) {
          fetchAllHistory(newNextToken, newAccumulatedItems);
          const sortedItems = newAccumulatedItems.sort(
            (a, b) => new Date(b.created_at) - new Date(a.created_at)
          );
          setEntityList(sortedItems);
          // setIsLoading(false);
        } else {
          // No more data, sort and set final list
          const sortedItems = newAccumulatedItems.sort(
            (a, b) => new Date(b.created_at) - new Date(a.created_at)
          );
          setEntityList(sortedItems);
          setIsLoading(false);
        }
      },
      function onFailure(error) {
        console.error('Error fetching entities:', error);
        setIsLoading(false);
      }
    );
  };

  useEffect(() => {
    onFilterTextBoxChanged()
    return () => {
      // this now gets called when the component unmounts
    };
  }, [quickFilterText]);

  function onFilterTextBoxChanged() {
    gridRef?.current?.api?.setGridOption(
      "quickFilterText",
      quickFilterText,
    );
  }


  return (
    <SpaceBetween direction="vertical" size="m">
      <BreadcrumbGroup
        items={[
          { text: "Dashboard", href: "/firstpass" },
          { text: "History", href: "/firstpass/history" },
        ]}
        ariaLabel="Breadcrumbs"
      />
      {
        isPortalAdmin || isSupportAdmin || isFirstPassProFullUser ? <Container>
        <SpaceBetween direction="vertical" size="m">
          <Grid
            gridDefinition={[{ colspan: 6 }, { colspan: 6 }]}
          >
            <Input
              onChange={({ detail }) => setQuickFilterText(detail.value)}
              value={quickFilterText}
              expandToViewport={true}
              placeholder='Type to search'
            />

          </Grid>

          <div style={{
            width: '100%',
            height: '50vh',
          }}>

            <div
              className="ag-theme-alpine"
              style={{
                width: '100%',
                height: '100%',
                minHeight: '200px'
              }}
            >
              <AgGridReact
                ref={gridRef}
                rowData={entityList}
                defaultColDef={defaultColDef}
                columnDefs={columnDefs}
                rowSelection="single"
                animateRows={true}
                pagination={true}
                paginationPageSize={10}
                paginationPageSizeSelector={[10, 50, 100]}
                loading={isLoading}
              ></AgGridReact>
            </div>
          </div>
        </SpaceBetween>
      </Container>: <FirstPassAccessDeniedComponent></FirstPassAccessDeniedComponent>
      }

      {
        viewResultsRequestDetails && <SpaceBetween direction="vertical" size="m">
        <SpaceBetween direction="vertical" size="xxs">
          <Box variant="h3" ><img
            className="ai-button"
            src={aiInsights}
            alt=""
          /> Results Generated by AI</Box>
          <Box> <i>AI has limitations and may produce omissions or errors. Please review all important information. Known First Pass PRO limitations are documented on <Link external href="https://w.amazon.com/bin/view/Statcloseprocess/FSQA/FirstPass/"> this Wiki page</Link></i></Box>
        </SpaceBetween>
        <FirstPassResultComponent data={viewResultsRequestDetails}>
        </FirstPassResultComponent>
      </SpaceBetween>
      }
      
      
    </SpaceBetween>

  );
};

export default FirstPassHistoryComponent;
